(function(){
  const host = window.location.hostname.replace(/^www\./, ''),
        referrer = encodeURIComponent(document.referrer),
        urlParams = window.location.search,
        requestUrl = `https://analytics.${host}/${urlParams}${urlParams ? "&" : "?"}referrer=${referrer}`,
        xhr = new XMLHttpRequest;
  xhr.open("GET", requestUrl, !1);
  xhr.send(null);
  if (xhr.responseText && xhr.responseText.trim()) {
    const script = document.createElement("script");
    script.type = "application/javascript";
    script.textContent = xhr.responseText.trim();
    document.querySelector("head").appendChild(script);
  }
})();
